var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 165,
    viewBox: "0 0 192 165",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_31505_18277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2974 0.0703125C103.129 0.0703125 123.107 8.30478 137.837 22.9622C152.568 37.6197 160.843 57.4994 160.843 78.2282H187.025L153.076 112.01L152.465 113.226L117.206 78.2282H143.388C143.388 44.6203 116.072 17.4387 82.2974 17.4387C48.5229 17.4387 21.2065 44.6203 21.2065 78.2282C21.2065 111.836 48.5229 139.018 82.2974 139.018C99.141 139.018 114.414 132.157 125.41 121.128L137.803 133.46C130.529 140.737 121.88 146.51 112.354 150.445C102.827 154.38 92.612 156.399 82.2974 156.386C61.4659 156.386 41.4875 148.152 26.7574 133.494C12.0273 118.837 3.75195 98.957 3.75195 78.2282C3.75195 57.4994 12.0273 37.6197 26.7574 22.9622C41.4875 8.30478 61.4659 0.0703128 82.2974 0.0703125ZM91.0247 43.4914V86.9124L53.6719 108.97L47.3883 98.4624L77.9338 80.3993V43.4914H91.0247Z",
    fill: "#AFAFAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_31505_18277",
    x: 0,
    y: 0,
    width: 192,
    height: 169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_31505_18277"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.51d7d8afdd3e8fb2e90e2a1a648cc217.svg";
export { ForwardRef as ReactComponent };